import React, { useEffect, useState } from 'react';
import {
  Card,
  CardText,
  CardTitle,
  SelectField,
  Cell,
  Grid,
  TextField,
  Button,
  Checkbox
} from "react-md";
import "../../css/mediaCss.css";
import Toggle from "react-toggle";
import { colorsArray,evaluateOptions,QueryOptions } from "./commonHelpers";
import copyIcon from '../../images/png/copy.png';
import crossIcon from '../../images/png/crossIcon.png';
import plusIcon from '../../images/png/plus.png';
import { DEFAULT_VECTOR_SNAP_TO_GIRD } from '../../pages/AssignmentMatrix/Constants';
import LabelPositionFields from "./LabelPositionFields";
import ColorPickerField from './ColorPickerField';
import VectorParserUtil from '../../lib/vector-math-parser';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { PiCaretDown } from "react-icons/pi";

const VectorAnswerFormula = ({ data, key, classNameString, onValueChange, index, vectorVariablesMap }) => {
  const [xEvaluateAdd,setXEvaluteAdd] = useState(data?.xAddFormulaSwitch ? data?.xAddFormulaSwitch :false)
  const [yEvaluateAdd,setYEvaluteAdd] = useState(data?.yAddFormulaSwitch ? data?.yAddFormulaSwitch :false)
  const [magEvaluateAdd,setMagEvaluteAdd] = useState(data?.magAddFormulaSwitch ? data?.magAddFormulaSwitch :false)
  const [angEvaluateAdd,setAngEvaluteAdd] = useState(data?.angAddFormulaSwitch ? data?.angAddFormulaSwitch :false)
  if (!data) {
    return null;
  }
  const {
    name,
    formulaType,
    angleFormula,
    magFormula,
    xFormula,
    yFormula,
    showLabel,
    labelPositionType,
    labelPositionX,
    labelPositionY,
    formulaColor,
    showImage,
    showComponents,
    showAngle,
    snapToGrid,
    autoOrigin,
    evaluate_x,
    evaluate_y,
    xOrigin,
    yOrigin,
    posX,
    posY,
    xEvaluateOption,
    xQueryOption,
    xAddFormulaSwitch,
    xEvaluateOptionTwo,
    xFormulaTwo,
    yEvaluateOption,
    yQueryOption,
    yEvaluateOptionTwo,
    yFormulaTwo,
    yAddFormulaSwitch,
    evaluate_magnitue,
    magEvaluateOption,
    magAddFormulaSwitch,
    magQueryOption,
    magEvaluateOptionTwo,
    magFormulaTwo,
    evaluate_angle,
    angEvaluateOption,
    angAddFormulaSwitch,
    angQueryOption,
    angEvaluateOptionTwo,
    angFormulaTwo,
    defaultAnswerType,
    validationMode,
    errorPercentageRange,
    errorAbsoluteRange,
    answerPrecision
  
  } = data;
  //Existing questions have no validation mode, default to error percentage with 0% (exact answer)
  const currentValidationMode = validationMode === null || validationMode === undefined ? "errorPercentage" : validationMode;
  const currentErrorPercentageRange = errorPercentageRange === null || errorPercentageRange === undefined ? "0" : errorPercentageRange;
  let help_text = {
    _x: "\\vec{A}_x + \\vec{B}_x ",
    _y: "\\vec{A}_y + \\vec{B}_y",
    _mag: "sqrt((\\vec{A}_mag*cos(\\vec{A}_ang))^2)",
    _ang: "atan(sin(\\vec{A}_ang)/cos(\\vec{A}_ang))"

     }
  const onChange = (name, value) => {
    const tempData = { ...data };
    tempData[name] = value;
    onValueChange(tempData);
  };
  const onXEvaluateAdd = () => {
    setXEvaluteAdd(!xEvaluateAdd)
    onChange("xAddFormulaSwitch",!xEvaluateAdd)
  };
  const onMagEvaluateAdd = () => {
    setMagEvaluteAdd(!magEvaluateAdd)
    onChange("magAddFormulaSwitch",!magEvaluateAdd)
  };
  const onAngEvaluateAdd = () => {
    setAngEvaluteAdd(!angEvaluateAdd)
    onChange("angAddFormulaSwitch",!angEvaluateAdd)
  };
  const onYEvaluateAdd = () => {
    setYEvaluteAdd(!yEvaluateAdd)
    onChange("yAddFormulaSwitch",!yEvaluateAdd)
  };

  const isSnapToGrid =
  snapToGrid === null || snapToGrid === undefined || snapToGrid === ""
    ? DEFAULT_VECTOR_SNAP_TO_GIRD
    : snapToGrid === "true";


  return (
    <Card className={classNameString} key={key} style={{ marginLeft: "0px" }}>
       <Accordion sx={{boxShadow:'none'}}>
        <AccordionSummary
                  expandIcon={<PiCaretDown fontSize={24} />}
                >
                  <div>
                    <div style={{fontSize: '24px'}}>
                      Vector Answer Formula {index !== null && index !== undefined ? `for Answer ${index+1}` : ""}
                    </div>
                    <div style={{fontSize: '14px', color:'gray'}}>Add formula for a vector answer</div>
                  </div>
                </AccordionSummary>

                <AccordionDetails>
      
      <CardText>
            <Grid style={{ marginLeft: "0px" }}>
              <Cell  size={2} >
                <TextField
                  id={`vector-name-${name}`}
                  className="textFieldClass"
                  value={name.trimStart()}
                  label="Name"
                  errorText="Name field cannot be empty"
                  required={true}
                  onChange={(value) => {
                    onChange("name", value);
                  }}
                />
              </Cell>
              <Cell size={2}>
                <SelectField
                  id={`vector-formula-${name}`}
                  helpText="Answer Formula Type ie Components or Angle/Magnitude"
                  label="Formula Type"
                  onChange={(value) => {
                    onChange("formulaType", value);
                  }}
                  name="formulaType"
                  menuItems={["components", "angle-magnitude"]}
                  value={formulaType}
                />
              </Cell>
              <Cell size={3}>
                <ColorPickerField 
                  value={formulaColor}
                  onChange={(value) => {
                      onChange("formulaColor", value);
                  }}
                />
              {/* <SelectField
                helpText="Answer Arrow Color"
                id={`text-color-answer-${name}`}
                label="Color"
                onChange={(value) => {
                  // variableObj.color = value;
                  onChange("formulaColor", value);
                }}
                menuItems={colorsArray}
                value={formulaColor}
              /> */}
              </Cell>
              <React.Fragment>
              <Cell  size={2}>
                    <TextField
                      id={`x-Origin-vector-${name}`}
                      disabled={autoOrigin}
                      className="textFieldClass"
                      type="number"
                      value={autoOrigin ? posX:xOrigin}
                      label="origin-x"
                      onChange={(value) => {
                        onChange("xOrigin", value);
                      }}
                      helpText="x component of vector"
                    />
              </Cell>
              <Cell  size={2}>
                    <TextField
                      id={`y-Origin-vector-${name}`}
                      disabled={autoOrigin}
                      className="textFieldClass"
                      type="number"
                      value={autoOrigin ? posY:yOrigin}
                      label="origin-y"
                      onChange={(value) => {
                        onChange("yOrigin", value);
                      }}
                      helpText="y component of vector"
                    />
              </Cell>
              </React.Fragment>
              
              {formulaType === "components" ? (
                <React.Fragment>
                  <Cell size={xEvaluateAdd ? 12 : 6} style={{padding:"0px"}} >

                    <Grid style={{border:"1px solid #9F9F9F",borderRadius:"5px" ,padding:"0px"}}>

                    <Cell size={2} style={{width:"65px" ,borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>

                      <label
                              className="vectors-toggle-label"
                            > 
                            <div  style={{ display: "flex",textWrap: "nowrap" ,fontSize:"12px",marginTop:xEvaluateAdd ? "50%" :"60%"}}>
                              <div >
                              Evaluate X
                              </div>
                              {/* <div>
                                <Button
                                  className="nocqcStyle"
                                  icon
                                  tooltipLabel="Evaluates only the X component of the answer drawn by the student and ignores the Y component."
                                >
                                  help
                                </Button>
                              </div> */}
                            </div>   
                      </label>
                        <Toggle
                              icons={false}
                              width={230}
                              defaultChecked={
                                evaluate_x ===  1 ? false : true //To cover existing Question, default will be true, 1 will be false
                              }
                          id={`auto-origin-check-${name}`}
                          name="evaluate_x"
                          onChange={(event) => {
                            onChange("evaluate_x", !event.target.checked ? 1 : 0);
                          }}
                          checked={evaluate_x === 1 ? false :true}
                        />
                    </Cell>
                    <Cell size={xEvaluateAdd ? 2 :3} style={{padding:"0px",margin:"0px",marginRight:"8px",marginTop:"2%"}}>   
                      <div style={{display:"flex",height:"100%"}}>
                          
                          <div  style={{ display: "flex",textWrap:"wrap",fontSize:"12px",paddingRight:"5px"}}>
                          <label
                              className="vectors-toggle-label"
                            > 
                              <div style={{marginTop: xEvaluateAdd ? "66%" :"100%",fontSize:"12px"}}>
                                X comp
                              </div>
                            </label>
                            </div>   
                          <div style={{paddingLeft:"10px"}}>

                            <SelectField
                                helpText="Select"
                                defaultValue={0}
                                style={{marginTop:xEvaluateAdd ? "33%" :"49%"}}
                                id={`text-color-answer-${name}`}
                                onChange={(value) => {
                                  onChange("xEvaluateOption", value);
                                }}
                                disabled={defaultAnswerType === 0 || defaultAnswerType === 1 }
                                menuItems={evaluateOptions}
                                value={xEvaluateOption}
                              />
                          </div>
                      </div>

                    </Cell>
                    <Cell size={xEvaluateAdd ? 3 : 4} style={{borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>    
                        <TextField
                          id={`x-Formula-vector-${name}`}
                          className="textFieldClass"
                          rows={1}
                          value={xFormula}
                          label="xFormula"
                          onChange={(value) => {
                            onChange("xFormula", value);
                          }}
                          helpText= {<div className="helpTextVector">
                                        Use  _x  after the variable name eg: 
                                      <Button className="helpTextVectorButton" tooltipLabel="copy"  
                                          onClick={() => {navigator.clipboard.writeText(help_text._x)}} >
                                        {help_text._x}
                                        </Button> 
                                    </div>
                                    } 
                        />
                      </Cell>
                      {!xEvaluateAdd ? 
                                    <Cell size={2} style={{margin:"0px"}}>
                                            <Button 
                                            className="sm-cell--left"
                                            style={{ width:"65px",marginLeft:"5px",marginTop:"25%",background:"#868E92",height:"80%",borderRadius:"5px",color:"white"}} 
                                            flat 
                                            onClick={()=> onXEvaluateAdd()}>
                                               
                                            Add
                                            another
                                            X
                                            Condition
                                            </Button>
                                    </Cell> : 
                                    
                                    
                                    <React.Fragment>

                                    <Cell size={1} style={{marginLeft:"10px",marginRight:"20px"}}>   
                                      <SelectField
                                           helpText="Select"
                                           id={`x-Formula-vector-${name}`}
                                          className="textFieldClass"
                                          onChange={(value) => {
                                            // variableObj.color = value;
                                            onChange("xQueryOption", value);
                                          }}
                                          style={{marginTop:"25%",paddingRight:"10px"}}
                                          menuItems={QueryOptions}
                                          value={xQueryOption}
                                          defaultValue={0}
                                        />
                                  </Cell>
                                      <Cell size={1} style={{borderLeft:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px"}}>   

                                          <SelectField
                                              helpText="Select"
                                              style={{marginTop:"35%",marginLeft:"10px"}}
                                              id={`text-color-answer-${name}`}
                                              onChange={(value) => {
                                                // variableObj.color = value;
                                                onChange("xEvaluateOptionTwo", value);
                                              }}
                                              defaultValue={0}
                                              menuItems={evaluateOptions}
                                              value={xEvaluateOptionTwo}
                                            />
                                      </Cell>
                                   <Cell size={3} style={{marginLeft:"30px"}}>    
                                    <div style={{display:"flex"}}>
                                      <div>

                                        <TextField
                                          id={`x-Formula-vector-${name}`}
                                          className="textFieldClass"
                                          rows={1}
                                          value={xFormulaTwo}
                                          label="xFormulaTwo"
                                          onChange={(value) => {
                                            onChange("xFormulaTwo", value);
                                          }}
                                          disabled={defaultAnswerType === 0 || defaultAnswerType === 1 }
                                          helpText= {<div className="helpTextVector">
                                                        Use  _x  after the variable name eg: 
                                                      <Button className="helpTextVectorButton" tooltipLabel="copy"  
                                                          onClick={() => {navigator.clipboard.writeText(help_text._x)}} >
                                                        {help_text._x}
                                                        </Button> 
                                                    </div>
                                                    } 
                                        />
                                      </div>
                                     <div>

                                         <Button  
                                              style={{marginTop:"132%"}}
                                              onClick={()=> onXEvaluateAdd()}>
                                              <img
                                                  src={crossIcon}
                                                  alt="Delete"
                                                  
                                                />
                                              </Button>
                                     </div>
                                    </div>
                                    </Cell>
                                   
                                    </React.Fragment>
                                    
                    }

                    </Grid>
                  </Cell>
                      <Cell size={yEvaluateAdd ? 12 : 6} style={{padding:"0px"}} >

                      <Grid style={{border:"1px solid #9F9F9F",borderRadius:"5px" ,padding:"0px"}}>
                     
                      <Cell size={2} style={{width:"65px" ,borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>

                        <label
                                htmlFor={`auto-origin-check-${name}`}
                                className="vectors-toggle-label"
                              >
                                  <div  style={{ display: "flex",textWrap:"nowrap",fontSize:"12px",marginTop:yEvaluateAdd ? "50%" :"60%"}}>
                              <div >
                              {"Evaluate Y"}
                              </div>
                              {/* <div>
                                <Button
                                  className="nocqcStyle"
                                  icon
                                  tooltipLabel="Evaluates only the Y component of the answer drawn by the student and ignores the X component."
                                >
                                  help
                                </Button>
                              </div> */}
                            </div>   
                              
                        </label>
                          <Toggle
                                icons={false}
                                defaultChecked={
                                  evaluate_y ===  1 ? false : true //To cover existing Question, default will be true, 1 will be false
                                }
                                width={230}
                            id={`auto-origin-check-${name}`}
                            name="evaluate_y"
                            onChange={(event) => {
                              onChange("evaluate_y", !event.target.checked ? 1 : 0);
                            }}
                            checked={evaluate_y  === 1 ? false :true}
                          />
                        </Cell>
                        <Cell size={yEvaluateAdd ? 2 :3} style={{padding:"0px",margin:"0px",marginRight:"8px",marginTop:"2%"}}>    
                            <div style={{display:"flex",height:"100%"}}>
                            <div  style={{ display: "flex",textWrap:"wrap",fontSize:"12px",paddingRight:"5px"}}>
                              <label
                                  className="vectors-toggle-label"
                                > 
                                  <div style={{marginTop:yEvaluateAdd ? "66%" :"100%",fontSize:"12px"}}>
                                    Y comp
                                  </div>
                                </label>
                                </div>   
                                <div style={{paddingLeft:"10px"}}>
                                  <SelectField
                                      helpText="Select"
                                      defaultValue={0}
                                      style={{marginTop:yEvaluateAdd ? "33%" :"49%"}}
                                      id={`text-color-answer-${name}`}
                                      onChange={(value) => {
                                        onChange("yEvaluateOption", value);
                                      }}
                                      disabled={defaultAnswerType === 0 || defaultAnswerType === 1 }
                                      menuItems={evaluateOptions}
                                      value={yEvaluateOption}
                                    />
                              </div>
                          </div>
                         

                        </Cell>
                        <Cell size={yEvaluateAdd ? 3 : 4} style={{borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>    
                          <TextField
                            id={`y-Formula-vector-${name}`}
                            className="textFieldClass"
                            rows={1}
                            value={yFormula}
                            label="yFormula"
                            onChange={(value) => {
                              onChange("yFormula", value);
                            }}
                            helpText={<div className="helpTextVector">
                                        Use  _y  after the variable name eg: 
                                        <Button className="helpTextVectorButton" tooltipLabel="copy"  
                                          onClick={() => {navigator.clipboard.writeText(help_text._y)}} >
                                          {help_text._y}
                                        </Button>
                                      </div>
                                      }
                          />
                        </Cell>
                        {!yEvaluateAdd ? 
                           <Cell size={2}  style={{margin:"0px"}} >
                            <Button 
                                 style={{ width:"65px",marginLeft:"5px",marginTop:"25%",background:"#868E92",height:"80%",borderRadius:"5px",color:"white"}} 
                                  flat 
                                  onClick={()=> onYEvaluateAdd()}>
                                     
                                  Add
                                  another
                                  y
                                  Condition
                                  </Button>
                         </Cell> :
                           
                           <React.Fragment>
                            <Cell size={1} style={{marginLeft:"10px",marginRight:"20px"}}>   
                               <SelectField
                                   helpText="Select"
                                   id={`text-color-answer-${name}`}
                                   onChange={(value) => {
                                     onChange("yQueryOption", value);
                                   }}
                                   style={{marginTop:"25%",paddingRight:"10px"}}
                                   menuItems={QueryOptions}
                                   value={yQueryOption}
                                   defaultValue={0}
                                 />
                           </Cell>
                           <Cell size={1} style={{borderLeft:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px"}}>   

                                <SelectField
                                helpText="Select"
                                style={{marginTop:"35%",marginLeft:"10px"}}
                                  id={`text-color-answer-${name}`}
                                  onChange={(value) => {
                                    onChange("yEvaluateOptionTwo", value);
                                  }}
                                  menuItems={evaluateOptions}
                                  value={yEvaluateOptionTwo}
                                  disabled={defaultAnswerType === 0 || defaultAnswerType === 1 }
                                  defaultValue={0}
                                />
                              
                           </Cell>
                           <Cell size={3} style={{marginLeft:"30px"}}> 
                              <div style={{display:"flex"}}>
                                    <div>

                                    <TextField
                                        id={`y-Formula-vector-${name}`}
                                        className="textFieldClass"
                                        rows={1}
                                        value={yFormulaTwo}
                                        label="yFormulaTwo"
                                        onChange={(value) => {
                                          onChange("yFormulaTwo", value);
                                        }}
                                        helpText={<div className="helpTextVector">
                                                    Use  _y  after the variable name eg: 
                                                    <Button className="helpTextVectorButton" tooltipLabel="copy"  
                                                      onClick={() => {navigator.clipboard.writeText(help_text._y)}} >
                                                      {help_text._y}
                                                    </Button>
                                                  </div>
                                                  }
                                      />
                                    </div>
                                    <div>

                                          <Button  
                                          style={{marginTop:"132%"}}
                                          onClick={()=> onYEvaluateAdd()}>
                                          <img
                                              src={crossIcon}
                                              alt="Delete"
                                              
                                            />
                                          </Button>
                                    </div>
                                </div>
                           </Cell>
                        </React.Fragment>
                        }
                      
                      </Grid>
                     </Cell>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Cell size={magEvaluateAdd ? 12 : 6} style={{padding:"0px"}} >
                  <Grid style={{border:"1px solid #9F9F9F",borderRadius:"5px" ,padding:"0px"}}>

                    <Cell size={2} style={{width:"65px" ,borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>

                        <label
                                  className="vectors-toggle-label"
                                > 
                                <div  style={{ display: "flex",textWrap: "wrap" ,fontSize:"12px",marginTop: magEvaluateAdd ? "50%" :"60%"}}>
                                  <div >
                                  Evaluate Magnitude
                                  </div>
                                </div>   
                          </label>
                            <Toggle
                                  icons={false}
                                  width={230}
                                  defaultChecked={
                                    evaluate_magnitue ===  1 ? false : true //To cover existing Question, default will be true, 1 will be false
                                      }
                                  id={`auto-origin-check-${name}`}
                                  name="evaluate_magnitue"
                                  onChange={(event) => {
                                    onChange("evaluate_magnitue", !event.target.checked ? 1 : 0);
                                  }}
                                  checked={evaluate_magnitue  === 1 ? false :true}
                                />
                    </Cell>
                    <Cell size={magEvaluateAdd ? 2 :3} style={{padding:"0px",margin:"0px",marginRight:"8px",marginTop:"2%"}}>   
                      <div style={{display:"flex",height:"100%"}}>
                          
                          <div  style={{ display: "flex",textWrap:"wrap",fontSize:"12px",paddingRight:"5px"}}>
                          <label
                              className="vectors-toggle-label"
                            > 
                              <div style={{marginTop:magEvaluateAdd ? "66%" :"100%",fontSize:"10px"}}>
                                Magnitude
                              </div>
                            </label>
                            </div>   
                          <div>

                            <SelectField
                                helpText="Select"
                                defaultValue={0}
                                style={{marginTop:magEvaluateAdd ? "33%" :"49%"}}
                                id={`text-color-answer-${name}`}
                                onChange={(value) => {
                                  onChange("magEvaluateOption", value);
                                }}
                                menuItems={evaluateOptions}
                                value={magEvaluateOption}
                              />
                          </div>
                      </div>

                    </Cell>
                    <Cell size={magEvaluateAdd ? 3 : 4} style={{borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>    
                          <TextField
                            id={`angle-formula-${name}`}
                            className="textFieldClass"
                            rows={1}
                            value={magFormula}
                            label="Magnitude Formula"
                            onChange={(value) => {
                              onChange("magFormula", value);
                            }}
                            helpText={<div className="helpTextVector">
                                      Use  _mag  after the variable name eg:
                                      <Button className="helpTextVectorButton" tooltipLabel="copy"  
                                          onClick={() => {navigator.clipboard.writeText(help_text._mag)}} > 
                                          {help_text._mag}
                                      </Button>
                                      </div>
                                      }
                            id="angle-formula-vector"
                          />
                      </Cell>
                      {!magEvaluateAdd ? 
                      <Cell size={2} style={{margin:"0px"}}>
                                <Button 
                                className="md-cell--left"
                                style={{ width: "92px",marginLeft:"3px",marginTop:"15%",background:"#868E92",height:"80%",borderRadius:"5px",color:"white"}} 
                                flat 
                                onClick={()=> onMagEvaluateAdd()}>
                                  
                                Add
                                another
                                Magnitude
                                Condition
                                </Button>
                        </Cell> : 
                         <React.Fragment>

                            <Cell size={1} style={{marginLeft:"10px",marginRight:"20px"}}>   
                              <SelectField
                                    helpText="Select"
                                    id={`mag-Formula-vector-${name}`}
                                  className="textFieldClass"
                                  onChange={(value) => {
                                    // variableObj.color = value;
                                    onChange("magQueryOption", value);
                                  }}
                                  style={{marginTop:"25%",paddingRight:"10px"}}
                                  menuItems={QueryOptions}
                                  value={magQueryOption}
                                  defaultValue={0}
                                />
                          </Cell>
                              <Cell size={1} style={{borderLeft:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px"}}>   

                                  <SelectField
                                      helpText="Select"
                                      style={{marginTop:"35%",marginLeft:"10px"}}
                                      id={`text-color-answer-${name}`}
                                      onChange={(value) => {
                                        // variableObj.color = value;
                                        onChange("magEvaluateOptionTwo", value);
                                      }}
                                      defaultValue={0}
                                      menuItems={evaluateOptions}
                                      value={magEvaluateOptionTwo}
                                    />
                              </Cell>
                            <Cell size={3} style={{marginLeft:"30px"}}>    
                            <div style={{display:"flex"}}>
                              <div>

                                 <TextField
                                  id={`angle-formula-${name}`}
                                  className="textFieldClass"
                                  rows={1}
                                  value={magFormulaTwo}
                                  label="Magnitude Formula"
                                  onChange={(value) => {
                                    onChange("magFormulaTwo", value);
                                  }}
                                  helpText={<div className="helpTextVector">
                                            Use  _mag  after the variable name eg:
                                            <Button className="helpTextVectorButton" tooltipLabel="copy"  
                                                onClick={() => {navigator.clipboard.writeText(help_text._mag)}} > 
                                                {help_text._mag}
                                            </Button>
                                            </div>
                                            }
                                  id="angle-formula-vector"
                                />
                              </div>
                              <div>

                                  <Button  
                                      style={{marginTop:"132%"}}
                                      onClick={()=> onMagEvaluateAdd()}>
                                      <img
                                          src={crossIcon}
                                          alt="Delete"
                                          
                                        />
                                      </Button>
                              </div>
                            </div>
                            </Cell>
                            
                            </React.Fragment>
                         
              
                        }
                  </Grid>

                  </Cell>
                  <Cell size={angEvaluateAdd ? 12 : 6} style={{padding:"0px"}} >
                    <Grid style={{border:"1px solid #9F9F9F",borderRadius:"5px" ,padding:"0px"}}>
                      <Cell size={2} style={{width:"65px" ,borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>

                      <label
                                className="vectors-toggle-label"
                              > 
                              <div  style={{ display: "flex",textWrap: "wrap" ,fontSize:"12px",marginTop:angEvaluateAdd ? "50%" : "60%"}}>
                                <div >
                                Evaluate Angle
                                </div>
                              </div>   
                        </label>
                          <Toggle
                                icons={false}
                                width={230}
                                defaultChecked={
                                  evaluate_angle ===  1 ? false : true //To cover existing Question, default will be true, 1 will be false
                                    }
                                id={`auto-origin-check-${name}`}
                                name="evaluate_angle"
                                onChange={(event) => {
                                  onChange("evaluate_angle", !event.target.checked ? 1 : 0);
                                }}
                                checked={evaluate_angle === 1 ? false :true}
                              />
                      </Cell>

                      <Cell size={angEvaluateAdd ? 2 :3} style={{padding:"0px",margin:"0px",marginRight:"8px",marginTop:"2%"}}>   
                      <div style={{display:"flex",height:"100%"}}>
                          
                          <div  style={{ display: "flex",textWrap:"wrap",fontSize:"12px",paddingRight:"5px"}}>
                          <label
                              className="vectors-toggle-label"
                            > 
                              <div style={{marginTop: angEvaluateAdd ? "66%" :"100%",fontSize:"12px"}}>
                                Angle
                              </div>
                            </label>
                            </div>   
                          <div>

                            <SelectField
                                helpText="Select"
                                defaultValue={0}
                                style={{marginTop:angEvaluateAdd ? "33%" :"49%"}}
                                id={`text-color-answer-${name}`}
                                onChange={(value) => {
                                  onChange("angEvaluateOption", value);
                                }}
                                menuItems={evaluateOptions}
                                value={angEvaluateOption}
                              />
                          </div>
                      </div>

                    </Cell>
                    <Cell size={angEvaluateAdd ? 3 :4 } style={{borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>    
                          <TextField
                            id={`mag-formula-${name}`}
                            className="textFieldClass"
                            rows={1}
                            value={angleFormula}
                            label="Angle Formula"
                            onChange={(value) => {
                              onChange("angleFormula", value);
                            }}
                            helpText={<div className="helpTextVector">
                                          Use  _ang  after the variable name eg: 
                                        <Button className="helpTextVectorButton" tooltipLabel="copy"  
                                          onClick={() => {navigator.clipboard.writeText(help_text._ang)}} > 
                                          {help_text._ang}
                                        </Button>
                                      </div>
                                      }
                          />
                      </Cell>
                      {!angEvaluateAdd ?  <Cell size={2} style={{margin:"0px"}}>
                                <Button 
                                className="md-cell--left"
                                style={{ width: "92px",marginLeft:"3px",marginTop:"15%",background:"#868E92",height:"80%",borderRadius:"5px",color:"white"}} 
                                flat 
                                onClick={()=> onAngEvaluateAdd()}>
                                  
                                Add
                                another
                                Angle
                                Condition
                                </Button>
                        </Cell> : 
                                <React.Fragment>

                                <Cell size={1} style={{marginLeft:"10px",marginRight:"20px"}}>   
                                  <SelectField
                                        helpText="Select"
                                        id={`mag-Formula-vector-${name}`}
                                      className="textFieldClass"
                                      onChange={(value) => {
                                        // variableObj.color = value;
                                        onChange("angQueryOption", value);
                                      }}
                                      style={{marginTop:"25%",paddingRight:"10px"}}
                                      menuItems={QueryOptions}
                                      value={angQueryOption}
                                      defaultValue={0}
                                    />
                              </Cell>
                                  <Cell size={1} style={{borderLeft:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px"}}>   
    
                                      <SelectField
                                          helpText="Select"
                                          style={{marginTop:"35%",marginLeft:"10px"}}
                                          id={`text-color-answer-${name}`}
                                          onChange={(value) => {
                                            // variableObj.color = value;
                                            onChange("angEvaluateOptionTwo", value);
                                          }}
                                          defaultValue={0}
                                          menuItems={evaluateOptions}
                                          value={angEvaluateOptionTwo}
                                        />
                                  </Cell>
                                <Cell size={3} style={{marginLeft:"30px"}}>    
                                <div style={{display:"flex"}}>
                                  <div>
    
                                    <TextField
                                      id={`angle-formula-${name}`}
                                      className="textFieldClass"
                                      rows={1}
                                      value={angFormulaTwo}
                                      label="Angle Formula Two"
                                      onChange={(value) => {
                                        onChange("angFormulaTwo", value);
                                      }}
                                      helpText={<div className="helpTextVector">
                                                Use  _mag  after the variable name eg:
                                                <Button className="helpTextVectorButton" tooltipLabel="copy"  
                                                    onClick={() => {navigator.clipboard.writeText(help_text._mag)}} > 
                                                    {help_text._mag}
                                                </Button>
                                                </div>
                                                }
                                      id="angle-formula-vector"
                                    />
                                  </div>
                                  <div>
    
                                      <Button  
                                          style={{marginTop:"132%"}}
                                          onClick={()=> onAngEvaluateAdd()}>
                                          <img
                                              src={crossIcon}
                                              alt="Delete"
                                              
                                            />
                                          </Button>
                                  </div>
                                </div>
                                </Cell>
                                
                                </React.Fragment>
                        }
                    </Grid>
                  </Cell>
                </React.Fragment>
              )}
             
              <Cell  size={2}>
              <label
                      htmlFor={`auto-origin-check-${name}`}
                      className="vectors-toggle-label"
                    >
                      {"Auto Origin"}
              </label>
                <Toggle
                      icons={false}
                      width={230}
                  id={`auto-origin-check-${name}`}
                  name="Auto Origin"
                  onChange={(event) => {
                    onChange("autoOrigin", event.target.checked);
                  }}
                  checked={autoOrigin}
                />
              </Cell>
              <Cell  size={2}>
              <label
                      htmlFor={`show-label-check-${name}`}
                      className="vectors-toggle-label"
                    >
                      {"Show Label"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                  id={`show-label-check-${name}`}
                  name="Show Label"
                  onChange={(event) => {
                    onChange("showLabel", event.target.checked);
                  }}
                  checked={showLabel}
                />
              </Cell>

          {/* Label positions */}
            <LabelPositionFields 
                id={name}
                showLabel={showLabel}
                type={labelPositionType ? labelPositionType : "Automatic"}
                onTypeChange={(newValue) => {
                    onChange("labelPositionType", newValue);
                }}
                xValue={labelPositionX ? labelPositionX : posX}
                onXValueChange={(newValue) => {
                    onChange("labelPositionX", newValue);
                }}
                yValue={labelPositionY ? labelPositionY : posY}
                onYValueChange={(newValue) => {
                    onChange("labelPositionY", newValue);
                }}
              />
              {/* <Cell  size={3}>
              <label
                      htmlFor={`show-image-check-${name}`}
                      className="vectors-toggle-label"
                    >
                      {"Show Image"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                  id={`show-image-check-${name}`}
                  name="Show Image"
                  onChange={(event) => {
                    onChange("showImage",event.target.checked);
                  }}
                  checked={showImage}
                />
              </Cell> */}
              <Cell  size={3}>
              <label
                      htmlFor={`show-components-check-${name}`}
                      className="vectors-toggle-label"
                    >
                      {"Show Components"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                  id={`show-components-check-${name}`}
                  name="Show Components"
                  onChange={(event) => {
                    onChange("showComponents", event.target.checked);
                  }}
                  checked={showComponents}
                />
              </Cell>
              <Cell  size={3}>
              <label
                      htmlFor={`show-angle-check-${name}`}
                      className="vectors-toggle-label"
                    >
                      {"Show Angle"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                  id={`show-angle-check-${name}`}
                  name="Show Angle"
                  onChange={(event) => {
                    onChange("showAngle", event.target.checked);
                  }}
                  checked={showAngle}
                  className="rp-fraction-checkbox"
                  label="Show Angle"
                />
              </Cell>
                
                {/* {formulaType === "components" ? 
                  <Cell size={3}>
                    <label
                        htmlFor={`show-snap-to-grid-check-${name}`}
                        className="vectors-toggle-label"
                      >
                        {"Snap to Grid"}
                      </label>
                      <Toggle
                        icons={false}
                        width={230}
                    id={`show-snap-to-grid-check-${name}`}
                    name="Snap to Grid"
                    onChange={(event) => {
                      onChange("snapToGrid", String(event.target.checked));
                    }}
                    checked={isSnapToGrid}
                    className="rp-fraction-checkbox"
                    label="Snap to Grid"
                  />
                </Cell>
              : null} */}
              
              {/* Computed Answer Display */}
              {vectorVariablesMap && (
                <Cell size={12} style={{ padding: "0px", marginTop: "6px" }}>
                  <div>Calculated Answer:</div>
                  {(() => {
                    const compute = (f) => { try { return VectorParserUtil.computeFormula(f, vectorVariablesMap); } catch { return "—"; } };
                    const rows = [];
                    if (formulaType === "components") {
                      if (xFormula && evaluate_x === 0) {
                        const v1 = compute(xFormula);
                        const v2 = xAddFormulaSwitch && xFormulaTwo ? compute(xFormulaTwo) : null;
                        rows.push({ label: "X", f1: xFormula, v1, op: xAddFormulaSwitch && xFormulaTwo ? (xQueryOption === 0 ? "AND" : "OR") : null, f2: xFormulaTwo, v2 });
                      }
                      if (yFormula && evaluate_y === 0) {
                        const v1 = compute(yFormula);
                        const v2 = yAddFormulaSwitch && yFormulaTwo ? compute(yFormulaTwo) : null;
                        rows.push({ label: "Y", f1: yFormula, v1, op: yAddFormulaSwitch && yFormulaTwo ? (yQueryOption === 0 ? "AND" : "OR") : null, f2: yFormulaTwo, v2 });
                      }
                    } else {
                      if (magFormula && evaluate_magnitue === 0) {
                        const v1 = compute(magFormula);
                        const v2 = magAddFormulaSwitch && magFormulaTwo ? compute(magFormulaTwo) : null;
                        rows.push({ label: "Mag", f1: magFormula, v1, op: magAddFormulaSwitch && magFormulaTwo ? (magQueryOption === 0 ? "AND" : "OR") : null, f2: magFormulaTwo, v2 });
                      }
                      if (angleFormula && evaluate_angle === 0) {
                        const v1 = compute(angleFormula);
                        const v2 = angAddFormulaSwitch && angFormulaTwo ? compute(angFormulaTwo) : null;
                        rows.push({ label: "Angle", f1: angleFormula, v1, op: angAddFormulaSwitch && angFormulaTwo ? (angQueryOption === 0 ? "AND" : "OR") : null, f2: angFormulaTwo, v2 });
                      }
                    }
                    if (rows.length === 0) return null;
                    const hasSecond = rows.some(r => r.op);
                    return (
                      <table style={{ fontSize: "11px", borderCollapse: "collapse", width: "auto" }}>
                        <thead>
                          <tr style={{ background: "#f5f5f5" }}>
                            <th style={{ padding: "3px 8px", textAlign: "left", fontWeight: 600, borderBottom: "1px solid #ddd" }}></th>
                            <th style={{ padding: "3px 8px", textAlign: "left", fontWeight: 600, borderBottom: "1px solid #ddd" }}>Formula 1</th>
                            <th style={{ padding: "3px 8px", textAlign: "right", fontWeight: 600, borderBottom: "1px solid #ddd" }}>Value</th>
                            {hasSecond && <th style={{ padding: "3px 8px", textAlign: "center", fontWeight: 600, borderBottom: "1px solid #ddd" }}>Op</th>}
                            {hasSecond && <th style={{ padding: "3px 8px", textAlign: "left", fontWeight: 600, borderBottom: "1px solid #ddd" }}>Formula 2</th>}
                            {hasSecond && <th style={{ padding: "3px 8px", textAlign: "right", fontWeight: 600, borderBottom: "1px solid #ddd" }}>Value</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((r, i) => (
                            <tr key={i} style={{ borderBottom: "1px solid #eee" }}>
                              <td style={{ padding: "3px 8px", fontWeight: 600, color: "#555" }}>{r.label}</td>
                              <td style={{ padding: "3px 8px", color: "#333" }}>{r.f1}</td>
                              <td style={{ padding: "3px 8px", textAlign: "right", fontWeight: 700 }}>{r.v1}</td>
                              {hasSecond && <td style={{ padding: "3px 8px", textAlign: "center", color: "#888", fontWeight: 600 }}>{r.op || ""}</td>}
                              {hasSecond && <td style={{ padding: "3px 8px", color: "#333" }}>{r.f2 || ""}</td>}
                              {hasSecond && <td style={{ padding: "3px 8px", textAlign: "right", fontWeight: 700 }}>{r.v2 || ""}</td>}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    );
                  })()}
                </Cell>
              )}

              {/* if snap to grid is OFF, show the answer validation just like for random param free response */}
              <React.Fragment>
                <Cell>
                  <SelectField
                      id={`draw-vector-validation`}
                      label="Answer Validation Mode"
                      placeholder="Choose a correct answer validation mode"
                      value={currentValidationMode}
                      menuItems={[
                        {
                          label: "Error percentage range",
                          value: "errorPercentage",
                        },
                        {
                          label: "Error absolute range",
                          value: "valueRange",
                        },
                        /* {
                          label: "Answer precision (Sig Figs)",
                          value: "precision",
                        }, */
                      ]}
                      helpText="Please choose how the correct answer should be validated"
                      onChange={(value) => {
                        onChange("validationMode", value);
                      }}
                    />
                </Cell>
              </React.Fragment>
              
              {currentValidationMode === "errorPercentage" ?
                 <Cell>
                    <TextField
                      fullWidth
                      id="randomised-formula-option"
                      label="Error percentage range"
                      value={currentErrorPercentageRange}
                      onChange={(value) => {
                        onChange("errorPercentageRange", value);
                      }}
                      helpText="In terms of percent. Example: “15” means +/- 15%, “0.03” means +/- 0.03%"
                    />
                  </Cell>
              : null}
              {currentValidationMode === "valueRange" ?
                 <Cell>
                    <TextField
                        fullWidth
                        id="randomised-formula-low-value"
                        label="Error absolute range"
                        value={errorAbsoluteRange}
                        onChange={(value) => {
                          onChange("errorAbsoluteRange", value);
                        }}
                        helpText="Example: “15” means +/- 15,  “0.02” means +/- 0.02."
                      />
                  </Cell>
              : null}
              {currentValidationMode === "precision" ?
                 <Cell>
                    <TextField
                      fullWidth
                      id="randomised-formula-precision"
                      label="Answer precision (Sig Figs)"
                      value={answerPrecision}
                      onChange={(value) => {
                        onChange("answerPrecision", value);
                      }}
                      helpText="Student answers with higher sig figs than specified here will be rounded. The answer precision (i.e., significant figures), must be consistent with the sig figs of input random parameters. Example: if the correct answer is 1.200 with a given answer precision 4, 1.199 is marked incorrect, but 1.1999 is marked correct because it is first rounded to 4 sig figs = 1.200"
                    />
                  </Cell>
              : null}

            </Grid>
      </CardText>
      </AccordionDetails>
      </Accordion>
    </Card>
  );
};

export default VectorAnswerFormula;
